import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const GROUP_CREATE_RESOURCE = "group" as const;
export const GROUP_CREATE_API_PATH = `/v1/${GROUP_CREATE_RESOURCE}` as const;

export type GroupCreateBody = paths[typeof GROUP_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type GroupCreateResponse =
  paths[typeof GROUP_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useGroupCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<GroupCreateResponse, Error, GroupCreateBody>({
    mutationFn: async (group: GroupCreateBody) => {
      const response = await alphartisApiAxios.post<GroupCreateResponse>(GROUP_CREATE_API_PATH, group);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GROUP_CREATE_RESOURCE],
      });
    },
  });
};
